import { Component, Input, OnInit, Output, EventEmitter, Injector, ViewChild, ElementRef, OnChanges, SimpleChanges } from '@angular/core';
import { endOfDay, startOfDay } from 'date-fns';
import { laaSFormatString } from 'src/app/core/utils/common-functions';
import { SessionBaseComponent } from '../session.base.component';
import { Calendar } from 'primeng/calendar';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'laas-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss']
})
export class CalendarComponent extends SessionBaseComponent implements OnInit, OnChanges {

  @Input() class!: any;
  @Input() requiredStar: boolean;
  @Input() title: string;
  @Input() isDivTitle: boolean;
  @Input() isH3Title: boolean;
  @Input() dateFormat;
  @Input() placeholder: string;
  @Input() minDate!: Date;
  @Input() maxDate!: Date;
  @Input() enableMaxDateIsToday?: boolean;
  @Input() selectionMode: 'single' | 'multiple' | 'range' | undefined = 'range';
  @Input() showTime;
  @Input() showButtonBar;
  @Input() showCustomButtonBar;
  @Input() defaultDate: any;
  @Input() showRangeMode: boolean;
  @Input() showStartMode: boolean;
  @Input() showEndMode: boolean;
  @Input() validateFunction!: () => boolean;
  @Input() monthRange: number = 3;
  @Output() onDateChange: EventEmitter<any>;
  isShow: boolean;
  date: any | null;
  showDate: any | null;
  calendarMode: string;
  defaultMinDate!: Date;
  defaultMaxDate!: Date;
  datePipeDateFormat: string = 'yyyy/MM/dd';
  displayValue: string = '';
  startDate: Date | null = null;
  endDate: Date | null = null;
  @Input() showSeconds: boolean;
  @Input() readonlyInput: boolean = true;
  @Input() reportFormat: boolean = false;
  @Input() showCustomTime: boolean = false;
  @Input() enableManualInput: boolean = false;
  private previousEndDateValue: Date | undefined;
  private lastTime: Date | null = null;
  private rangeCompleted = false;
  private isPickingRange = false;
  private readonly DATE_TIME_RANGE_REGEX = /^(\d{4}\/\d{2}\/\d{2} \d{2}:\d{2}:\d{2}) - (\d{4}\/\d{2}\/\d{2} \d{2}:\d{2}:\d{2})$/;

  @ViewChild('calendar') calendar!: Calendar;
  @ViewChild('manualInput') manualInput!: ElementRef<HTMLInputElement>;

  constructor(
    injector: Injector) {
    super(injector);
    this.requiredStar = false;
    this.title = '';
    this.isDivTitle = false;
    this.isH3Title = false;
    this.dateFormat = 'yy/mm/dd';
    this.placeholder = '';
    this.showTime = false;
    this.showButtonBar = false;
    this.showCustomButtonBar = false;
    this.defaultDate = null;
    this.showRangeMode = false;
    this.showStartMode = false;
    this.showEndMode = false;
    this.isShow = false;
    this.date = this.defaultDate;
    this.showDate = this.defaultDate;
    this.calendarMode = 'Single';
    this.isPickingRange = false;
    this.onDateChange = new EventEmitter();
    this.showSeconds = false;
  }

  async ngOnInit(): Promise<void> {
    if (this.selectionMode === 'range') {
      this.calendarMode = 'Range';
    }

    if (!this.showRangeMode && !this.showStartMode && !this.showEndMode) {
      this.calendarMode = 'Single';
    }

    this.defaultMinDate = this.minDate;
    this.defaultMaxDate = this.maxDate;

    if (this.enableMaxDateIsToday && this.calendarMode !== 'Range') {
      let today = new Date();
      today.setHours(23, 59, 59, 999);
      this.maxDate = today;
    }
    if (this.showCustomTime) {
      this.datePipeDateFormat = 'yyyy/MM/dd HH:mm:ss';
      this.lastTime = new Date();
    }

    setTimeout(() => {
      this.date = this.defaultDate;
      this.showDate = this.defaultDate;
      if (this.calendarMode === 'Range') {
        this.date = this.defaultDate;
        this.showDate = this.defaultDate;
        if (Array.isArray(this.defaultDate) && this.defaultDate[0] && this.defaultDate[1]) {
          this.startDate = new Date(this.defaultDate[0]);
          this.endDate = new Date(this.defaultDate[1]);
          this.rangeCompleted = true;
        }
      } else {
        this.date = null;
        this.showDate = null;
        }
      if (this.showCustomTime && this.defaultDate) {
        if (Array.isArray(this.defaultDate)) {
          const s = this.defaultDate[0];
          if (s instanceof Date) {
            this.lastTime = new Date(s);
          }
        } else if (this.defaultDate instanceof Date) {
          this.lastTime = new Date(this.defaultDate);
          }
      }

  this.displayValue = this.formatDisplayValue();
    }, 100);

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['defaultDate'] && !changes['defaultDate'].isFirstChange()) {
      const newVal = changes['defaultDate'].currentValue;
      this.syncUIFromOutside(newVal);
    }
  }

  async onChange(event: any): Promise<void> {

    var returnDate = { date: undefined, startDate: undefined, endDate: undefined };

    if (!event) {
      this.onDateChange.emit(returnDate);
      return;
    }

    if (this.showCustomTime) {

      if (!this.lastTime) {
        this.lastTime = new Date();
      }

      if (Array.isArray(event)) {

        if (event[0]) {
          event[0] = new Date(event[0]);
          event[0].setHours(
            this.safeLastTime.getHours(),
            this.safeLastTime.getMinutes(),
            this.showSeconds ? this.safeLastTime.getSeconds() : 0,0);
        }
      } else {
        event = new Date(event);
        event.setHours(
          this.safeLastTime.getHours(),
          this.safeLastTime.getMinutes(),
          this.showSeconds ? this.safeLastTime.getSeconds() : 0,0);
      }
    }

    if (event) {
      var date: any;
      var startDate: any;
      var endDate: any;
      switch (this.calendarMode) {
        case 'Start':
          startDate = event;

          if (!this.showCustomTime) {
            startDate = startOfDay(event);
          }
          break;

        case 'End':
          endDate = event;

          if (!this.showCustomTime) {
            endDate = endOfDay(event);
          }
          break;

        case 'Range':
          startDate = event[0];
          endDate = event[1] ?? null;

          if (!this.showDate && this.reportFormat) { //如果沒有預設日期時間，時間就會先設定為0:0:0
            startDate.setHours(0, 0, 0, 0)
          }

          if (!this.showCustomTime) {
            startDate = startOfDay(event[0]);

              if (event[1]) {
                endDate = endOfDay(event[1]);
              }
          }

          if (this.showCustomTime && !this.showSeconds) {

            if (endDate instanceof Date) {
              endDate.setHours(23, 59, 59, 999);
            }
          }

          if (this.showCustomTime && this.reportFormat) { //endDate預設時間為23:59:59

            if (this.isEndDateChanged(endDate)) {
              endDate.setHours(23, 59, 59, 999);
            }
            this.previousEndDateValue = endDate;
          }

          if (endDate) {
            let beforeThreeMonth = new Date(endDate);
            beforeThreeMonth.setHours(0, 0, 0, 0);
            const _year1 = beforeThreeMonth.getFullYear();
            const _month1 = beforeThreeMonth.getMonth() - this.monthRange;
            const _lastDay1 = new Date(_year1, _month1 + 1, 0).getDate();
            beforeThreeMonth = new Date(_year1, _month1, Math.min(beforeThreeMonth.getDate(), _lastDay1));

            if (startDate < beforeThreeMonth) {
              this.date = undefined;
              this.showDate = undefined;
              startDate = undefined;
              endDate = undefined;

              if (this.defaultDate) {
                this.date = this.defaultDate;
                this.showDate = this.defaultDate;
              }

              var instantMsg = await this.translateService.get("Common.Message.DateRangeCannotExceedSeveralMonths").toPromise();
              var msg = `${laaSFormatString(instantMsg, [this.monthRange.toString()])}\n`
              this.toastService.warn(msg);
            }

          }
          break;

        case 'Single':
          date = event;

          if (!this.showCustomTime) {
            date = startOfDay(event);
          }
          break;
      }

      if (this.showCustomTime) {

        if (!this.lastTime) this.lastTime = new Date();
          const applyTime = (d: Date) => {
            d.setHours(
              this.safeLastTime!.getHours(),
              this.safeLastTime!.getMinutes(),
              this.showSeconds ? this.safeLastTime!.getSeconds() : 0,0);
        };

        if (date instanceof Date) applyTime(date);

        if (startDate instanceof Date) applyTime(startDate);
      }
      if (this.calendarMode === 'Range') {

        if (startDate && endDate) {
          this.date = [startDate, endDate];
          this.showDate = this.date;
        }
      } else {
          this.date = date ?? startDate ?? endDate ?? null;
          this.showDate = null;
        }

      this.displayValue = this.formatDisplayValue();
      returnDate = { date: date, startDate: startDate, endDate: endDate };
    }

    this.onDateChange.emit(returnDate);
  }

  isEndDateChanged(newDate: Date): boolean {

    if (this.defaultDate && this.defaultDate[1] && !this.previousEndDateValue) {
      this.previousEndDateValue = this.defaultDate[1];
    }

    if (!this.previousEndDateValue) {
      return true;
    }

    return newDate.getFullYear() !== this.previousEndDateValue.getFullYear() ||
      newDate.getMonth() !== this.previousEndDateValue.getMonth() ||
      newDate.getDate() !== this.previousEndDateValue.getDate();
  }

  changeCalendarMode(event: any): void {

    setTimeout(() => {
      this.clearDate();
      switch (this.calendarMode) {
        case 'Start':

          if (!this.defaultMinDate) {
            let currentDate = new Date();
            currentDate.setMonth(currentDate.getMonth() - this.monthRange);
            this.minDate = currentDate;
          }

          this.selectionMode = 'single';

          break;

        case 'End':

          this.selectionMode = 'single';
          break;

        case 'Range':

          if (!this.defaultMinDate) {
            this.minDate = new Date(0);
          }

          this.selectionMode = 'range';

          break;
      }
    }, 200);
  }

  changeSelectMode(mode: string) {
    this.calendarMode = mode;
    this.changeCalendarMode(null);
  }

  clearDate(): void {
    this.date = null;
    this.showDate = null;
    this.startDate = null;
    this.endDate = null;
    this.isPickingRange = false;
    this.rangeCompleted = false;
    this.displayValue = '';
    if (this.calendar) {
      this.calendar.value = null;
      this.calendar.updateModel(null);
    }
    const emptyResult = {
      date: undefined,
      startDate: undefined,
      endDate: undefined
    };
    this.onDateChange.emit(emptyResult);
    this.onChange(null);
  }

  changeDate(event: Event, option: number): void {
    let today = new Date();
    let currentMonth = today.getMonth();
    let currentYear = today.getFullYear();
    let startDate = new Date();

    switch (option) {
      case 2:
        startDate.setDate(today.getDate() - today.getDay());
        break;
      case 3:
        startDate.setDate(today.getDate() - 3);
        break;
      case 4:
        startDate.setDate(today.getDate() - 7);
        break;
      case 5:
        startDate.setDate(today.getDate() - 14);
        break;
      case 6:
        var startDateMonth = (currentMonth === 0) ? 11 : currentMonth - 1;
        var startDateYear = (startDateMonth === 11) ? currentYear - 1 : currentYear;
        startDate.setMonth(startDateMonth);
        startDate.setFullYear(startDateYear);
        break;
      default:
        break;
    }

    this.date = [startDate, today];
    this.showDate = [startDate, today];
    this.onChange(this.date);
  }

  changeShowDate(date: any) {
    if (this.calendarMode === 'Range') return;
    if (date.lenght >= 2) {
      this.date = [date[0], date[1]];
      this.onChange(this.date);
    } else {
      this.date = date;
      this.onChange(this.date);
    }
  }

  getTimeSliderValue(): Date {

    if (!this.lastTime) {
      this.lastTime = new Date();
    }
    return new Date(this.lastTime);
  }

  onTimeSliderValueChange(updated: Date) {
    if (!updated) return;

    this.lastTime = new Date(updated);

    const applyTime = (d: Date | null): Date | null => {
      if (!d) return null;
      const newDate = new Date(d)
      newDate.setHours(
        this.safeLastTime.getHours(),
        this.safeLastTime.getMinutes(),
        this.showSeconds ? this.safeLastTime.getSeconds() : 0, 0);
        return newDate;
    };

    if (this.rangeCompleted && this.endDate) {
    this.endDate = applyTime(this.endDate);
  } else if (this.startDate) {
    this.startDate = applyTime(this.startDate);
  }

    this.showDate = [this.startDate, this.endDate];
    this.displayValue = this.formatDisplayValue();

    this.onDateChange.emit({
      startDate: this.startDate ?? undefined,
      endDate: this.endDate ?? undefined
    });
  }



  formatDisplayValue(): string {
    if (!this.showDate && !this.date) return '';

    if (!this.showCustomTime) {

      if (Array.isArray(this.showDate)) {
        const s = this.showDate[0];
        const e = this.showDate[1];

        if (s && e) {
          return `${this.formatDateOnly(s)} - ${this.formatDateOnly(e)}`;
        }
        return s ? this.formatDateOnly(s) : '';
      }

      return this.date instanceof Date ? this.formatDateOnly(this.date) : '';
    }

    if (!this.lastTime) {
      this.lastTime = new Date();
    }

    const formatDateTime = (d: Date) => {
      const yyyyMMdd = this.formatDateOnly(d);
      const hh = this.pad(d.getHours());
      const mm = this.pad(d.getMinutes());
      const ss = this.pad(d.getSeconds());

      return this.showSeconds? `${yyyyMMdd} ${hh}:${mm}:${ss}`: `${yyyyMMdd} ${hh}:${mm}`;
    }

    if (Array.isArray(this.showDate)) {
      const s = this.showDate[0];
      const e = this.showDate[1];

      if (s && e) {
        return `${formatDateTime(s)} - ${formatDateTime(e)}`;
      }

      return s ? formatDateTime(s) : '';
    }

    if (this.date instanceof Date) {
      return formatDateTime(this.date);
    }

    return '';
  }

  private formatDateOnly(d: Date): string {

    const y = d.getFullYear();
    const m = this.pad(d.getMonth() + 1);
    const day = this.pad(d.getDate());

    return `${y}/${m}/${day}`;
  }

  private pad(n: number): string {

    return n.toString().padStart(2, '0');

  }

  openCalendar() {

    const cal: any = this.calendar;

    if (!cal) return;
    const input: HTMLInputElement | null = cal.inputfieldViewChild?.nativeElement;

    if (!input) return;

    requestAnimationFrame(() => {
      setTimeout(() => {
        input.focus();
        cal.showOverlay();
      }, 0);
    });
  }


  async onCalendarSelect(selected: any) {

    if (this.calendarMode === 'Range') {
      if (this.rangeCompleted) {
        this.startDate = null;
        this.endDate = null;
        this.rangeCompleted = false;
      }

      if (!(selected instanceof Date)) return;
      const currentViewDate = new Date(selected);

      if (!this.startDate) {
        const startPicked = new Date(selected);
        if (this.showCustomTime) {
          startPicked.setHours(
          this.safeLastTime.getHours(),
          this.safeLastTime.getMinutes(),
          this.showSeconds ? this.safeLastTime.getSeconds() : 0, 0);
        } else {
          startPicked.setHours(0, 0, 0, 0); // 強制 00:00:00
          }

        this.startDate = startPicked;
        this.endDate = null;
        this.rangeCompleted = false;
        this.keepViewDate(currentViewDate);
        this.showDate = [this.startDate, null];
        this.displayValue = this.formatDisplayValue();
        this.onDateChange.emit({ startDate: this.startDate, endDate: null });
        return;
      }

      const endPicked = new Date(selected);
      if (this.showCustomTime) {
        endPicked.setHours(
        this.safeLastTime.getHours(),
        this.safeLastTime.getMinutes(),
        this.showSeconds ? this.safeLastTime.getSeconds() : 0, 0);
      } else {
        endPicked.setHours(23, 59, 59, 999); // 強制 23:59:59
        }

      // 日期範圍卡控
      let beforeThreeMonth = new Date(endPicked);
      beforeThreeMonth.setHours(0, 0, 0, 0);
      const _year2 = beforeThreeMonth.getFullYear();
      const _month2 = beforeThreeMonth.getMonth() - this.monthRange;
      const _lastDay2 = new Date(_year2, _month2 + 1, 0).getDate();
      beforeThreeMonth = new Date(_year2, _month2, Math.min(beforeThreeMonth.getDate(), _lastDay2));

      if (this.startDate < beforeThreeMonth) {
        const instantMsg = await firstValueFrom(this.translateService.get("Common.Message.DateRangeCannotExceedSeveralMonths"));
        this.toastService.warn(`${laaSFormatString(instantMsg, [this.monthRange.toString()])}\n`);
        this.clearDate();
        return;
      }

      this.endDate = endPicked;
      this.rangeCompleted = true;
      this.date = [this.startDate, this.endDate];
      this.keepViewDate(currentViewDate);
      this.showDate = [this.startDate, this.endDate];
      this.displayValue = this.formatDisplayValue();

      if (this.rangeCompleted) {
        if (this.enableManualInput) {
          this.handleFocusAndCaret();
        }
      }

      this.onDateChange.emit({
        date: undefined,
        startDate: this.startDate,
        endDate: this.endDate
      });
      return;
    }

    // ===== Single / Start / End =====
    if (!(selected instanceof Date)) return;

    const picked = new Date(selected);
    if (this.showCustomTime) {
      picked.setHours(
        this.safeLastTime.getHours(),
        this.safeLastTime.getMinutes(),
        this.showSeconds ? this.safeLastTime.getSeconds() : 0, 0);
    } else {
      if (this.calendarMode === 'End') {
        picked.setHours(23, 59, 59, 999);
        } else {
          picked.setHours(0, 0, 0, 0);
        }
      }

    this.date = picked;

    if (this.calendarMode === 'Start') {
      this.startDate = picked;
      this.endDate = null;
    } else if (this.calendarMode === 'End') {
      this.endDate = picked;
    }

    this.showDate = null;
    this.displayValue = this.formatDisplayValue();

    this.onDateChange.emit({
      date: this.date,
      startDate: this.startDate ?? undefined,
      endDate: this.endDate ?? undefined
    });
  }

  private keepViewDate(date: Date) {
    if (this.calendar) {
      const cal = this.calendar as any;
      cal.viewDate = new Date(date);
    }
}

  private get safeLastTime(): Date {

    if (!this.lastTime) {
      this.lastTime = new Date();
    }

    return this.lastTime;
  }

  onManualInput(event: any) {
    const inputValue = event.target.value?.trim();
    if (!inputValue) {
      this.clearDate();
      return;
    }
    const match = inputValue.match(this.DATE_TIME_RANGE_REGEX);
    if (match) {
      const startStr = match[1];
      const endStr = match[2];
      const newStart = new Date(startStr);
      const newEnd = new Date(endStr);

      if (!isNaN(newStart.getTime()) && !isNaN(newEnd.getTime())) {

        if (newStart <= newEnd) {
          this.startDate = newStart;
          this.endDate = newEnd;
          this.date = [this.startDate, this.endDate];
          this.showDate = [this.startDate, this.endDate];
          this.rangeCompleted = true;
          this.displayValue = this.formatDisplayValue();
          this.onDateChange.emit({ startDate: this.startDate, endDate: this.endDate });
          return;
        }
      }
    }
    this.clearDate();
  }

  private handleFocusAndCaret() {
    if (!this.enableManualInput) return;
      const performFocus = () => {
    const inputEl = this.manualInput?.nativeElement;
    if (inputEl) {
      inputEl.value = this.displayValue;
      inputEl.focus();
      const len = inputEl.value.length;
      inputEl.setSelectionRange(len, len);
    }
  };
    setTimeout(performFocus, 200);
    setTimeout(performFocus, 500);
  }

  onCalendarClose() {
  this.handleFocusAndCaret();
  }

  public syncUIFromOutside(val: any): void {
    if (!val) {
      this.clearDate();
      return;
    }
    if (Array.isArray(val)) {
      this.startDate = val[0] ? new Date(val[0]) : null;
      this.endDate = val[1] ? new Date(val[1]) : null;
      this.rangeCompleted = !!(this.startDate && this.endDate);
      this.date = [this.startDate, this.endDate];
      this.showDate = [this.startDate, this.endDate];
    } else {
      this.date = new Date(val);
      this.showDate = null;
      this.startDate = this.date;
      this.endDate = null;
    }
    const refDate = Array.isArray(val) ? val[0] : val;
    if (refDate && this.calendar) {
      this.keepViewDate(new Date(refDate));
    }
    this.displayValue = this.formatDisplayValue();
  }
}


